export default {
  setDashboard(state, data) {
    state.dashboard = data;
  },

  setTransactionReport(state, data) {
    state.transactionReport = data;
  },
};
